module.exports = __webpack_public_path__ + "img/红黑 1@2x.e0c53def.png";